import { Injectable } from "@angular/core";
import { AmazonService } from "../../../services/amazon.service";
import { SearchResponse } from "../../../objects/responses/searchResponse";
import { Seller } from "../../../objects/amazon/seller";


@Injectable()
export class AmazonSellerManagementResolver {
    constructor(private amazonService: AmazonService) {
    }

    public resolve(): Promise<SearchResponse<Seller>> {
        return this.amazonService.getSellers(0, 12).then(result => {
            return result.Data;
        }).catch(err => {
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/amazon-management/amazon-seller-management.resolver.ts